import * as types from '../mutation-types';

// Toda aba da lista precisa de página inicial: sem ela a próxima página vira
// NaN, o backend devolve sempre a primeira e a lista recarrega sem parar.
// "ai" (Atendimento IA) e "unread" (Não lidas) são abas do Fluxi.
const paginaInicial = () => ({
  me: 0,
  unassigned: 0,
  all: 0,
  ai: 0,
  unread: 0,
  appliedFilters: 0,
});

const fimNaoAlcancado = () => ({
  me: false,
  unassigned: false,
  all: false,
  ai: false,
  unread: false,
  appliedFilters: false,
});

const state = {
  currentPage: paginaInicial(),
  hasEndReached: fimNaoAlcancado(),
};

export const getters = {
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter];
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter];
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    if (filter === 'all') {
      $state.hasEndReached = {
        ...$state.hasEndReached,
        unassigned: true,
        me: true,
      };
    }
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.currentPage = paginaInicial();
    $state.hasEndReached = fimNaoAlcancado();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
